import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=463df8e6&scoped=true&"
import script from "./MobileMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=463df8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463df8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463df8e6')) {
      api.createRecord('463df8e6', component.options)
    } else {
      api.reload('463df8e6', component.options)
    }
    module.hot.accept("./MobileMenu.vue?vue&type=template&id=463df8e6&scoped=true&", function () {
      api.rerender('463df8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/elements/MobileMenu.vue"
export default component.exports